<template>
  <div>
    <BannerLogo />
    <OverviewSection title="Our Philosophy" gradient bg="secondary">
      <p>
        The demand for greater value and accountability in healthcare is fundamentally changing the competitive landscape. Our strong experience in sales and consumer-centric marketing, in conjunction with efficient operating expertise, shapes our value as a partner.
      </p>
    </OverviewSection>
    <OverviewSection title="Our Investment Strategy">
      <p>
        Guided by decades of diverse healthcare operating experience, we actively work with portfolio companies to build local and regional businesses into a national platform. We apply our backgrounds and experiences to increase the strategic value of our portfolio companies.
      </p>
      <v-sheet class="pa-6 ma-12 text-h5 light-green lighten-5 secondary--text elevation-3">
        We seek to be ideal partners with founders, owners and management.
      </v-sheet>
      <p>
        Typical later-stage investment candidates, in which we primarily consider acquiring majority ownership stakes, are companies with over $10M in revenue and with greater than $1M in EBITDA.
      </p>
      <p>
        We also actively seek to provide growth equity and form partnerships with promising companies in the early stages of development.
      </p>
    </OverviewSection>
    <OverviewSection title="Operational Relationship" bg="primary" gradient>
      <p>
        We believe our operationally-focused approach appeals to founders and owners who seek a value-added investment partner, particularly in building strong sales and marketing entities.
      </p>
      <p>
        Our relationships with portfolio owners are based on respect and the common goal of providing strategic opportunities and accelerating growth to build shareholder value.
      </p>
    </OverviewSection>
    <OverviewSection title="Our Experience">
      <p>
        All HealthView investment partners have succeeded as CEOs, Presidents and Board members of companies in multiple facets of healthcare delivery, including:
      </p>
      <v-row>
        <v-col cols="12" md="6">
          <ul>
            <li>Clinical Trials</li>
            <li>Home Healthcare</li>
            <li>Medical Devices</li>
            <li>Hospice</li>
            <li>Hospital Systems</li>
            <li>Consumer Products</li>
          </ul>
        </v-col>
        <v-col>
          <ul>
            <li>Medical Education</li>
            <li>Skilled Nursing Facilities</li>
            <li>Physician Practice Management</li>
            <li>Rural Health Clinics</li>
            <li>Rehabilitation Companies</li>
          </ul>
        </v-col>
      </v-row>
    </OverviewSection>
  </div>
</template>

<script>
import OverviewSection from '@/components/overview/OverviewSection'
import BannerLogo from '@/components/core/BannerLogo'
export default {
  name: 'Overview',
  components: {
    OverviewSection,
    BannerLogo,
  },
  metaInfo: {
    title: 'Overview',
    meta: [
      {description: 'The demand for greater value and accountability in healthcare is fundamentally changing the competitive landscape. Our strong experience in sales and consumer-centric marketing shapes our value as a partner.'}
    ]
  },
  data() {
    return {
      title: 'Overview',
    }
  },
  methods: {},
}
</script>
